import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

// service that controls console logs and allows them to be written when not in production
@Injectable({
	providedIn: 'root'
})
export class LogService {
	public consoleLog(message: string, err?: unknown): void {
		if (!environment.production) {
			console.log(message, err);
		}
	}

	public consoleError(error: string, err?: unknown): void {
		if (!environment.production) {
			console.error(error, err);
		}
	}
}
